import { render, staticRenderFns } from "./payment-type.vue?vue&type=template&id=c26650ec"
import script from "./payment-type.vue?vue&type=script&lang=ts"
export * from "./payment-type.vue?vue&type=script&lang=ts"
import style0 from "./payment-type.vue?vue&type=style&index=0&id=c26650ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports